export default function isMediaQuery(property) {
  return property.substr(0, 6) === '@media';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/node_modules/fela-utils/es/isMediaQuery.js
// module id = 775
// module chunks = 0